export default {
	title: "Rapports",
	selectReport: "Sélectionnez un rapport à consulter",
	ritualReport: "Rapport de rituel",
	noClosedRituals: "Aucun rituel clôturé trouvé",
	requiresClosed: "Le rituel doit être clôturé pour accéder au rapport.",
	closings: {
		title: "Clôtures de rituels",
		description: "Rapports détaillés des rituels clôturés",
		totalClosed: "Rituels clôturés",
	},
	print: "Imprimer",
	sendEmail: "Envoyer par e-mail",
	emailSent: "Rapport envoyé à votre e-mail",
	emailError: "Erreur lors de l'envoi du rapport par e-mail",
	printHeader: {
		printedAt: "Imprimé le",
	},
	back: "Retour",
	header: {
		type: "Type",
		spiritualLine: "Ligne spirituelle",
		date: "Date",
		location: "Lieu",
		openedBy: "Ouvert par",
		closedBy: "Clôturé par",
	},
	stats: {
		title: "Statistiques",
		ritualDuration: "Durée du rituel",
		attendanceDuration: "Durée de la consultation",
		firstCall: "Premier appel",
		lastCall: "Dernier appel",
		avgIncremental: "Temps moyen (à la demande)",
		avgPreDefined: "Temps moyen (fixe)",
		totalTickets: "Total des fiches",
		cancelledTickets: "Annulées",
		newPersons: "Nouvelles personnes",
		minutes: "min",
		notAvailable: "N/D",
	},
	tickets: {
		title: "Fiches de consultation",
		code: "Fiche",
		person: "Personne",
		createdAt: "Créée le",
		calledAt: "Appelée le",
		finishedAt: "Terminée le",
		elapsed: "Durée",
		status: "Statut",
		medium: "Médium",
		guide: "Guide",
		avgTime: "Temps moyen",
		noTickets: "Aucune fiche dans ce groupe",
	},
	messages: {
		title: "Messages",
		type: "Type",
		severity: "Gravité",
		message: "Message",
		person: "Personne",
		createdBy: "Créé par",
	},
	returns: {
		fulfilledTitle: "Retours accomplis dans ce rituel",
		newTitle: "Nouveaux retours",
		returnType: "Type",
		person: "Personne",
		target: "Cible",
		status: "Statut",
		notes: "Notes",
		fulfilled: "Accompli",
		pending: "En attente",
	},
	general: {
		title: "Rapport Général des Rituels",
		menuTitle: "Rapport Général",
		fetchError: "Erreur lors du chargement du rapport",
		exportPdf: "Exporter en PDF",
		pdfError: "Erreur lors de la génération du PDF",
		minutesShort: "min",
		filters: {
			status: "Statut",
			allPeriods: "Toute la période",
		},
		empty: {
			title: "Aucun rituel sur la période",
			description: "Ajustez la période ou les statuts sélectionnés pour voir les résultats.",
		},
		groups: {
			byRitual: "Vue par rituel",
			byType: "Répartition par type",
			mediums: "Performance des médiums",
		},
		kpis: {
			rituals: "Rituels",
			completedTickets: "Consultations",
			distinctPersons: "Personnes reçues",
			cancelledTickets: "Fiches annulées",
			totalTime: "Temps total",
			avgTime: "Temps moyen",
		},
		charts: {
			ticketsByRitual: "Consultations par rituel",
			ticketsByRitualType: "Consultations par type de rituel",
			avgByRitualType: "Moyenne de consultations par type de rituel",
			ticketDistribution: "Répartition des fiches",
			topMediumsByTime: "Médiums avec le plus de temps de consultation",
			topMediumsByAvg: "Médiums avec la meilleure moyenne de consultations",
			attendances: "Consultations",
			avgAttendances: "Moyenne de consultations",
			attendancesShort: "cons.",
			tickets: "fiches",
			completed: "Terminées",
			notCompleted: "Non terminées",
			cancelled: "Annulées",
			totalTime: "Temps total",
		},
		byMedium: {
			title: "Par médium",
			medium: "Médium",
			attendances: "Consultations",
			rituals: "Rituels",
			totalTime: "Temps total",
			avgTime: "Temps moyen",
			empty: "Aucun médium avec des consultations sur la période",
		},
		byGuide: {
			title: "Par guide",
			guide: "Guide",
			medium: "Médium",
			attendances: "Consultations",
			totalTime: "Temps total",
			avgTime: "Temps moyen",
			empty: "Aucun guide avec des consultations sur la période",
		},
	},
};
